// The app's handle on the boot screen.
//
// The screen itself is not in this bundle. It is a chunk of its own, built from
// boot-screen/main.js and loaded ahead of the app — the reasoning is written out
// there. It publishes one function on window, and this is the app's side of
// that: an import, so the call sites read like any other, over a global, which
// is all two separate graphs can share.

const HOST_ID = 'preload-spinner';

/**
 * Take the screen away.
 *
 * Falls back to removing the screen outright when the boot screen's own module
 * is not there to do it gracefully — it is a separate request now, and a 404 or
 * a browser that refused it would otherwise leave the ground and the caption
 * covering the app for the rest of the session. Nothing else would take them
 * away: they are written into index.html, not rendered by anything the app owns.
 */
export function dismissBootScreen(options = {}) {
  const screen = window.__resourcedBootScreen;
  if (screen) return screen.dismiss(options);

  document.getElementById(HOST_ID)?.remove();
  return Promise.resolve();
}
